/**
 * Completion Guards
 *
 * These guards ensure users have completed necessary steps in their journey.
 * They handle business logic requirements beyond basic authentication.
 *
 * Guards:
 * - checkParentRegistration: Ensures premium parents have completed address registration
 */
import { Route, NavigationGuardNext } from 'vue-router';
import redirectParentRegistration from '@/helpers/redirectParentRegistration';
import { setupApollo } from '@/lib/apollo_setup';
import store from '../../store';

const checkParentRegistration = async (_to: Route, _from: Route, next: NavigationGuardNext) => {
  const account = store.getters['account/getAccount'];

  if (account?.isPremium()) {
    try {
      const apolloProvider = setupApollo();
      await redirectParentRegistration(apolloProvider);
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error('Error in redirectParentRegistration:', error);
    }
  }

  next();
};

export default checkParentRegistration;
